<template>
    <div class="o-services services">
        <OContentHeader
            icon="services"
            :title="$t('ui.service-category')"
            :sub-title="$t('ui.service-category.description')"
        />
        <OTiles
            :items-per-block="12"
            :items="getSortedItemsByLetters"
            @tileClick="showServicesModal"
        >
            <template #default="{ button }">
                <OServicesTile
                    :icon-src="button.files.icon"
                    :name="t(button, 'name')"
                    :objects-count="button.objectsCount"
                />
            </template>
        </OTiles>
        <OSortingPanel
            v-model="sortingValue"
            :defined-buttons="definedButtons"
            :label="$t('ui.show')"
        />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import OTiles from '../../organisms/o-tiles/o-tiles';
import OSortingPanel from '../../organisms/o-sorting-panel/o-sorting-panel';
import OContentHeader from '../../organisms/o-content-header/o-content-header';
import OServicesTile from '../../unique-organisms/o-services-tile/o-services-tile';

import { SHOW_MODAL } from '../../../utils/constants/bus-events-constants'

import sortButtons from '../../../utils/mixins/sort-buttons';
import sortByLetters from '../../../utils/mixins/sort-by-letters';

export default {
    name: "OServices",
    mixins: [sortByLetters, sortButtons],
    components: {
        OTiles,
        OServicesTile,
        OSortingPanel,
        OContentHeader
    },
    computed: {
        ...mapState({
            activeLocale: state => state.activeLocale
        }),
        ...mapGetters([
            't',
            'getServiceCategories'
        ]),
        getItems() {
            const items = [...this.getServiceCategories];
            return items.sort((a, b) => this.t(a, 'name').localeCompare(this.t(b, 'name'), this.activeLocale));
        }
    },
    methods: {
        showServicesModal(data) {
            const params = {
                component: 'services',
                data: data
            };
            this.$bus.$emit(SHOW_MODAL, params);
        }
    }
}
</script>

<style lang="scss">
@import "o-services";
</style>
